import React, { useEffect, useState } from "react";
import { PhoneNumberField, Button } from "@aws-amplify/ui-react";
import { useFade } from "../../../hooks/useFade";
import { checkStatesAndPhoneNumber } from "../Signup.service";
import { handlePaste } from "../../../utils/helperFunctions";
import FullNameContainer from "../Components/FullNameContainer";
import { useSignup } from "../../../contexts/SignupContext";
import { determineUserType } from "../../../utils/UserType";

const StepOne = ({ handleChange, handleStepChange, queryParams, step }: any) => {
  const { given_name, family_name, phone_number, setIncomplete, allowedCountries, incomplete } = useSignup();
  const userType = determineUserType();
  const [countryList, setCountryList] = useState<string[] | null | undefined>();

  useEffect(() => {
    setIsVisible(true);
    checkStatesAndPhoneNumber([given_name, family_name], phone_number, userType, step, setIncomplete);
  }, []);

  useEffect(() => {
    checkStatesAndPhoneNumber([given_name, family_name], phone_number, userType, step, setIncomplete);
  }, [given_name, family_name, phone_number]);

  useEffect(() => {
    if (allowedCountries) {
      const sortedCountries = allowedCountries
        .map((el: any) => parseInt(el.replace(/\s/g, "")))
        .sort()
        .map((el: any) => el.toString().replace(/^/, "+"));
      if (allowedCountries?.length === 0) {
        setCountryList(null);
      } else {
        setCountryList(sortedCountries);
      }
    }
  }, [allowedCountries]);

  const [isVisible, setIsVisible, fadeProps] = useFade(false);
  return (
    <div {...fadeProps}>
      <FullNameContainer handleChange={handleChange} given_name={given_name} family_name={family_name} />
      <PhoneNumberField
        label="Phone Number"
        autoComplete="tel-national"
        onChange={(e) => handleChange("phoneNumber", e)}
        onDialCodeChange={(e) => handleChange("countryCode", e)}
        defaultValue={phone_number}
        isRequired={true}
        onPaste={handlePaste}
        dialCodeList={countryList ? countryList : undefined}
        onKeyPress={(e) => {
          if (!/[0-9]/.test(e.key)) {
            e.preventDefault();
          }
        }}
        crossOrigin={undefined}
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
      />
      <Button
        isFullWidth={true}
        onClick={handleStepChange}
        isDisabled={!queryParams || incomplete ? true : false}
        placeholder={undefined}
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
      >
        Next
      </Button>
    </div>
  );
};

export default StepOne;
